export const Card = ({ className = "", children, ...rest }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-shadow duration-200 hover:shadow-md sm:p-6 ${className}`} {...rest}>
    {children}
  </div>
);

export const PageHeader = ({ title, sub, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 data-testid="page-title" className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
      {sub && <p className="mt-1 text-sm text-slate-500 sm:text-base">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Empty = ({ text }) => (
  <div data-testid="empty-state" className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500">{text}</div>
);
